import React from "react";
import { toast } from "react-toastify";

const ProjectActions = ({ formData, onSave, loading }) => {
  const handleSaveChanges = async () => {
    if (!formData) {
      toast.error("Kaydedilecek veri bulunamadı");
      return;
    }

    try {
      await onSave();
      toast.success("Değişiklikler başarıyla kaydedildi");
    } catch (error) {
      toast.error(
        error?.message || "Değişiklikler kaydedilirken bir hata oluştu"
      );
    }
  };

  return (
    <div className="flex justify-end gap-4 mt-6">
      {/* <button
        className="btn-white w-[184px] h-[56px] text-sm"
        disabled={loading}
      >
        Projeyi Yayınla
      </button> */}

      <button
        className="btn-green w-[184px] h-[56px] text-sm"
        onClick={handleSaveChanges}
        disabled={loading}
      >
        {loading ? "Kaydediliyor..." : "Değişiklikleri Kaydet"}
      </button>
    </div>
  );
};

export default ProjectActions;
